import React from "react";
import { useState } from "react";
import {
  Image,
  H5,
  Btn
} from "../../../../../AbstractElements";
import {
  Col,
  Card,
  CardHeader,
  Table,
  Modal,
  ModalBody,
  Button,
} from "reactstrap";
import { handleDeleteAssets } from "../../TestimonyProgramUtils";
import DualListBoxTestimony from "./DualListBoxTestimony";

const TestimonyProgramListDetail = ({
  title,
  items,
  dispatch,
  setRefetch
}) => {
  const [modal, setModal] = useState(false);
  const [image, setImage] = useState("");

  const openModal = (url) => {
    setImage(url);
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
    setImage("");
  };

  return (
    <Col>
      <Card>
        <CardHeader>
          <H5>
            List {title || ""}
          </H5>
        </CardHeader>
        <div>
          <Table className="table-responsive" >
            <thead className="table-light">
              <tr>
                {title === "Gambar" ? <th scope="col" width="30"><DualListBoxTestimony data={items} /></th> : <th scope="col">{"#"}</th>}
                <th scope="col" className={`${title === "Gambar" ? "text-center" : ""}`}>
                  {title === "Gambar" ? "Gambar" : "Nama Program"}
                </th>
                <th scope="col" className="text-center">{"ID "}</th>
                {
                  title === "Gambar" && <th scope="col" className="text-center" colSpan="2">{"Aksi"}</th>
                }
              </tr>
            </thead>
            <tbody>
              {items &&
                items.map((item, index) => (
                  <tr key={`item-${index}`} id={item.id}>
                    <th className="text-center">{index + 1}</th>
                    <td className={`${title === "Gambar" ? "text-center w-25" : "handle"}`}>
                      {
                        title === "Gambar" ?
                          <Image key={index} attrImage={{ className: 'img-thumbnail', src: item.url }} />
                          :
                          item.title
                      }
                    </td>
                    <td className="text-center" style={{ width: "50px" }}>{item.id}</td>
                    {
                      title === "Gambar" &&
                      <td className="text-center handle" style={{ lineHeight: title === "Gambar" ? "72px" : "auto" }}>
                        <Button className="py-1 px-2" style={{ marginRight: "5px" }} color="primary" onClick={() => openModal(item.url)}>
                          <i className="fa fa-info-circle mx-auto fa-lg"></i>
                        </Button>
                        <Btn
                          attrBtn={{
                            color: "link",
                            outline: true,
                            className: "btn-xs btn-danger",
                            onClick: () => {
                              handleDeleteAssets(dispatch, item.id, setRefetch)
                            },
                          }}>
                          <i className="fa fa-trash fa-lg"></i>
                        </Btn>
                      </td>
                    }
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </Card>

      <Modal
        isOpen={modal}
        toggle={closeModal}
        size="md"
        className="modal-dialog-centered">
        <ModalBody>
          <Image attrImage={{ className: 'img-thumbnail', src: image }} />
        </ModalBody>
      </Modal>
    </Col>
  );
};

export default TestimonyProgramListDetail;
